import { BBAAccount, BBABalance } from "components/blockchain";
import { IAccount } from "interfaces/account.interface";
import { Link } from "react-router-dom";
import { sentenceCase } from "text-case";

export function GeneralOverview({ address }: { address: IAccount }) {
  return (
    <div className="mt-6 px-2.5 md:mt-12 md:px-3 lg:px-5">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <div className="box bg-white p-5 dark:bg-darkPrimary">
          <div className="flex flex-col gap-3">
            <h1 className="text-large mb-2.5">Overview</h1>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">BBA Balance</span>
              <span>
                <BBABalance daltons={address.daltons} displayFiat />
              </span>
            </div>
            {/* <div className="flex min-w-[100px] justify-between">
            <span className="text-gray-700">Holding Tokens</span>
            <span>
              $5,6587 <span className="text-gray-700">(200 Tokens)</span>
            </span>
          </div> */}
          </div>
        </div>
        <div className="box overflow-hidden bg-white p-5 dark:bg-darkPrimary">
          <div className="flex flex-col gap-3">
            <h1 className="text-large mb-2.5">More Info</h1>
            {/* Account Label */}
            {address.label && (
              <div className="flex justify-between">
                <span className="text-gray-700">Public Name</span>
                <span className="">{address.label}</span>
              </div>
            )}

            <div className="flex justify-between">
              <span className="text-gray-700">Owner</span>
              <div className="flex items-center">
                <BBAAccount address={address.owner} link />
                {/* <span className="mr-2 text-green-900">System Program</span>
              <button className="text-gray-700 dark:text-gray-300">
                <IoIosCopy />
              </button> */}
              </div>
            </div>
            {/* <div className="flex justify-between">
            <span className="text-gray-700">Transactions Sent</span>
            <span className="">Latest:10 secs ago</span>
          </div> */}
          </div>
        </div>
        <div className="box overflow-hidden bg-white p-5 dark:bg-darkPrimary">
          <div className="flex flex-col gap-3">
            <h1 className="text-large mb-2.5">More Info</h1>
            <div className="flex justify-between">
              <span className="text-gray-700">Allocated Data Size</span>
              <span className="text-black dark:text-white">
                {address.space} byte(s)
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-700">Exectable</span>
              <span className="text-black dark:text-white">
                {address.executable ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function VoteOverview({ address }: { address: IAccount }) {
  const authorizedVoter =
    address.data.parsed.parsed.info.authorizedVoters[0].authorizedVoter;
  const authorizedWithdrawer =
    address.data.parsed.parsed.info.authorizedWithdrawer;
  return (
    <div className="mt-6 px-2.5 md:mt-12 md:px-3 lg:px-5">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <div className="box bg-white p-5 dark:bg-darkPrimary">
          <div className="flex flex-col gap-3">
            <h1 className="text-large mb-2.5">Overview</h1>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">BBA Balance</span>
              <span>
                <BBABalance daltons={address.daltons} displayFiat />
              </span>
            </div>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Authorized Voter
              </span>
              <Link
                className="w-[200px] truncate"
                to={`/address/${authorizedVoter}`}
              >
                {authorizedVoter}
              </Link>
            </div>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Authorized Withdrawer
              </span>
              <Link
                className="w-[200px] truncate"
                to={`/address/${authorizedWithdrawer}`}
              >
                {authorizedWithdrawer}
              </Link>
            </div>
          </div>
        </div>
        <div className="box overflow-hidden bg-white p-5 dark:bg-darkPrimary">
          <div className="flex flex-col gap-3">
            <h1 className="text-large mb-2.5">More Info</h1>
            {/* Account Label */}
            {address.label && (
              <div className="flex justify-between">
                <span className="text-gray-700">Public Name</span>
                <span className="text-black dark:text-white">
                  {address.label}
                </span>
              </div>
            )}

            <div className="flex justify-between">
              <span className="text-gray-700">Owner</span>
              <div className="flex items-center">
                <BBAAccount address={address.owner} link />
                {/* <span className="mr-2 text-green-900">System Program</span>
              <button className="text-gray-700 dark:text-gray-300">
                <IoIosCopy />
              </button> */}
              </div>
            </div>
            {/* <div className="flex justify-between">
            <span className="text-gray-700">Transactions Sent</span>
            <span className="">Latest:10 secs ago</span>
          </div> */}
          </div>
        </div>
        <div className="box overflow-hidden bg-white p-5 dark:bg-darkPrimary">
          <div className="flex flex-col gap-3">
            <h1 className="text-large mb-2.5">Misc</h1>
            <div className="flex justify-between">
              <span className="text-gray-700">Commission</span>
              <span className="text-black dark:text-white">
                {address.data.parsed.parsed.info.commission + "%"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-700">Allocated Data Size</span>
              <span className="text-black dark:text-white">
                {address.space} byte(s)
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-700">Exectable</span>
              <span className="text-black dark:text-white">
                {address.executable ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function StakeOverview({ address }: { address: IAccount }) {
  const statusType = address.data.parsed.parsed.type;
  const stakeAuthority = address.data.parsed.parsed.info.meta.authorized.staker;
  const withdrawAuthority =
    address.data.parsed.parsed.info.meta.authorized.withdrawer;
  return (
    <div className="mt-6 w-full px-2.5 md:mt-12 md:px-3 lg:px-5">
      <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2">
        <div className="box w-full bg-white p-5 dark:bg-darkPrimary">
          <div className="flex flex-col gap-3">
            <h1 className="text-large mb-2.5">Overview</h1>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">BBA Balance</span>
              <span>
                <BBABalance daltons={address.daltons} displayFiat />
              </span>
            </div>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Rent Reserve (BBA)
              </span>
              <span className="text-black dark:text-white">
                {address.data.parsed.parsed.info.meta.rentExemptReserve +
                  " BBA"}
              </span>
            </div>
          </div>
          <div className="mt-7 flex flex-col gap-3">
            <h1 className="text-large mb-2.5">Authorities</h1>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Stake Authority Address
              </span>
              <Link
                className="w-[200px] truncate text-black dark:text-white"
                to={`/address/${stakeAuthority}`}
              >
                {stakeAuthority}
              </Link>
            </div>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Withdraw Authority Address
              </span>
              <Link
                className="w-[200px] truncate text-black dark:text-white"
                to={`/address/${withdrawAuthority}`}
              >
                {withdrawAuthority}
              </Link>
            </div>
          </div>
        </div>
        <div className="box w-full bg-white p-5 dark:bg-darkPrimary">
          <div className="flex flex-col gap-3">
            <h1 className="text-large mb-2.5">Overview</h1>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">Status</span>
              <span className="text-black dark:text-white">
                {sentenceCase(statusType) +
                  ` ${statusType === "delegated" ? "(active)" : "(inactive)"}`}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Delegated Stake (BBA)
              </span>
              <span className="text-black dark:text-white">
                {address.data?.parsed?.parsed?.info?.stake?.delegation?.stake +
                  " BBA"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Active Stake (BBA)
              </span>
              <span className="text-black dark:text-white">
                {address.data?.parsed?.activation?.active + " BBA"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Inactive Stake (BBA)
              </span>
              <span className="text-black dark:text-white">
                {address.data?.parsed?.activation?.inactive + " BBA"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Delegated Vote Address
              </span>
              <Link
                className="w-[200px] truncate text-black dark:text-white"
                to={`/address/${address.data?.parsed?.parsed?.info?.stake?.delegation?.voter}`}
              >
                {address.data?.parsed?.parsed?.info?.stake?.delegation?.voter}
              </Link>
            </div>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Activation Epoch
              </span>
              <span className="text-black dark:text-white">
                {
                  address.data?.parsed?.parsed?.info?.stake?.delegation
                    ?.activationEpoch
                }
              </span>
            </div>
            <div className="flex justify-between">
              <span className="min-w-[100px] text-gray-700">
                Deactivation Epoch
              </span>
              <span className="text-black dark:text-white">
                {
                  address.data?.parsed?.parsed?.info?.stake?.delegation
                    ?.deactivationEpoch
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
